import React, { memo } from "react";
import {
  Badge,
  Button,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Skeleton,
  Stack,
  styled,
} from '@material-ui/core';

import { areEqual, FixedSizeList, ListChildComponentProps } from 'react-window';

import { actions } from '../../services/support';
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { RootState } from "../../store";
import useResizeAware from "react-resize-aware";
import { ProfileAvatar } from "../../components/UserPhoto/UserPhoto";
import { ChatData } from "../../types";
import { useRef } from "react";
import timeAgo from "../../utils/timeAgo";
import { StringParam, useQueryParam } from "use-query-params";
import { navigate } from "@reach/router";



interface ListData {
  chats: ChatData[];
  currentSelected?: string | null;
}

const SupportItem: React.FC<ListChildComponentProps<ListData>> = ({ data, style, index }) => {

  const users = useSelector((state: RootState) => state.users.users);

  if (index === data.chats.length) {
    return <Button style={style}>Load More</Button>;
  }

  const chat = data.chats[ index ] as ChatData;

  const userId = chat.users[ 0 ] === 'admin' ? chat.users[ 1 ] : chat.users[ 0 ];


  return (
    <ListItem disablePadding style={style}>
      <ListItemButton
        selected={data.currentSelected === chat.id}
        onClick={() => {
          navigate(`/support?id=${chat.id}`);
        }}
      >
        <ListItemIcon>
          <ProfileAvatar userId={userId} />
        </ListItemIcon>
        <ListItemText
          primary={users[ userId ] ? users[ userId ].firstName : ''}
          secondary={timeAgo(chat.updateTime.toDate())}
        />
        <Badge badgeContent={chat.unseenMessagesCount[ 'admin' ]} color="secondary" />

      </ListItemButton>
    </ListItem>
  );
}


const SupportItemMemo = memo(SupportItem, areEqual);


const Root = styled('div')({
  position: 'relative',
  height: '100%',
  maxWidth: 250,
  width: '100%',
});

const SupportChatList: React.FC = () => {

  const [ selectedChat ] = useQueryParam('id', StringParam);
  const listRef = useRef(null);

  const [ resizeListener, size ] = useResizeAware();

  const state = useSelector((state: RootState) => state.support);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(actions.loadChats());

    return () => {
      dispatch(actions.resetChats());
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Root>
      {resizeListener}
      {
        state.chatsLoading ? (
          <Stack direction="column" sx={{pl: 1, pr: 1}}>
            <Skeleton width="100%" height={70}/>
            <Skeleton width="100%" height={70} />
            <Skeleton width="100%" height={70} />
          </Stack>
        ) : (
          <List disablePadding>
            <FixedSizeList
              height={size.height || 0}
              width={size.width || 0}
              itemCount={state.chats.length > 0 ? state.chats.length + 1 : 0}
              itemSize={70}
              itemData={{
                chats: state.chats,
                currentSelected: selectedChat,
              }}
              ref={listRef}
            >
              {SupportItemMemo}
            </FixedSizeList>
          </List>
        )
      }
    </Root>
  );
};

export default SupportChatList;